import { render, staticRenderFns } from "./DowntimeReasons.vue?vue&type=template&id=e6ce5348&scoped=true"
import script from "./DowntimeReasons.vue?vue&type=script&lang=js"
export * from "./DowntimeReasons.vue?vue&type=script&lang=js"
import style0 from "./DowntimeReasons.vue?vue&type=style&index=0&id=e6ce5348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ce5348",
  null
  
)

export default component.exports